/**
 * Native Credit Pool (wNLP) read surface.
 *
 * wNLP is **not** ERC-4626 — `asset()`, `totalAssets()` and
 * `convertToAssets()` all revert. It is a bespoke ERC-20 wrapper over the
 * rebasing NTLP pool share, with its own rate/redemption getters. Selectors
 * cross-checked against the published interface in the Native docs
 * (`depositAndWrap 0x57aa3d60`, `instantRedeem 0x22928208`,
 * `requestWithdrawal 0x9ee679e8`, `claimWithdrawal 0x6e66d84a`).
 */
export const NativeWnlpReadAbi = [
  {
    // 1e18-scaled underlying-per-share, independent of token decimals:
    // `getNlpByWnlp(1e18) / 1e18` is the exchange rate (per Native docs).
    name: 'getNlpByWnlp',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'wnlpAmount' }],
    outputs: [{ type: 'uint256' }],
  },
  {
    /** Instant-redeem haircut in basis points (0.1 %–2 %, default 1 %). */
    name: 'instantRedeemFeeBips',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    /** Some assets disable the instant leg entirely — queue only. */
    name: 'instantRedeemEnabled',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'bool' }],
  },
  {
    /** Per-wNLP WithdrawQueue contract (the delayed-redeem leg). */
    name: 'withdrawQueue',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'address' }],
  },
  {
    /** The rebasing NTLP pool share this wNLP wraps. */
    name: 'nlp',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'address' }],
  },
  {
    name: 'underlying',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'address' }],
  },
] as const

/** WithdrawQueue read surface — the queued-redeem waiting period. */
export const NativeWithdrawQueueReadAbi = [
  {
    /** Seconds between `requestWithdrawal` and `claimWithdrawal`
     *  (1–8 days depending on the asset; 3 days is the common value). */
    name: 'withdrawalWindow',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
